export default __webpack_public_path__ + "static/media/nph_flowchart.385f0260.png";